import React, { useState, useEffect, useCallback } from 'react'
import { Grid, Button, Select, MenuItem, FormControl, InputLabel, TextField, FormControlLabel, RadioGroup, Radio, Switch } from '@mui/material'
import moment from 'moment/moment'
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

// import iconUpPhoto from '../iconUpPhoto.svg'
import { Ubi } from '../model'
// import { DialogPreviewImage } from '../../modals/previewImage/DialogPreviewImage'

const clasificacion = ['cliente', 'proveedor']

export const SeccionGeneral = ({ form, setForm, openMas, setOpenMas, handleChange, selectedImage, setSelectedImage }) => {

    const [ubis, setUbis] = useState({})
    // const [openFiles, setOpenFiles] = useState(false)

    const [selectedCountry, setSelectedCountry] = useState([])
    const [selectedState, setSelectedState] = useState([])
    const [selectedProvince, setSelectedProvince] = useState([])
    const [selectedDistric, setSelectedDistric] = useState([])

    const getUbi = async () => {
        const dataUbi = await Ubi()
        setUbis(dataUbi)
    }

    const initialUbis = useCallback(() => {
        setSelectedCountry(ubis.countries)

        if (form.id_pais) {
            setSelectedState(ubis.deptos?.filter(it => it.id_pais === form.id_pais))
        }

        if (form.id_departamento) {
            setSelectedProvince(ubis.prov?.filter(it => it.id_estado_region === form.id_departamento))
        }

        if (form.id_provincia) {
            setSelectedDistric(ubis.distritos?.filter(it => it.id_provincias === form.id_provincia))
        }

    }, [form.id_pais, form.id_departamento, form.id_provincia, ubis])

    const handleChangeDate = (newValue) => {
        // console.log(newValue)
        setForm({
            ...form,
            aniversario: newValue
        })
    }

    const handleChangeUbi = ({ target }) => {
        // console.log(target.name, target.value)

        if (target.name === 'id_pais') {
            setSelectedState(ubis.deptos.filter(s => s.id_pais === target.value))

            setForm({
                ...form,
                id_pais: target.value,
                id_departamento: null,
                id_provincia: null,
                id_distrito: null

            })

        }

        if (target.name === 'id_departamento') {
            setSelectedProvince(ubis.prov.filter(p => p.id_estado_region === target.value))

            setForm({
                ...form,
                id_departamento: target.value,
                id_provincia: null,
                id_distrito: null

            })

        }

        if (target.name === 'id_provincia') {
            setSelectedDistric(ubis.distritos.filter(p => p.id_provincias === target.value))

            setForm({
                ...form,
                id_provincia: target.value,
                id_distrito: null

            })

        }

        if (target.name === 'id_distrito') {

            setForm({
                ...form,
                id_distrito: target.value
            })

        }

    }

    const handleChangeDate2 = (newValue) => {
        // console.log(newValue)
        setForm({
            ...form,
            fecha_nacimiento: newValue
        })
    }

    // const handleUpload = () => {
    //     document.getElementById('profile_picture').click()
    // }

    // const imageChange = (e) => {
    //     if (e.target.files && e.target.files.length > 0) {
    //         setSelectedImage(e.target.files[0])
    //         setOpenFiles(true)
    //     }
    // }

    useEffect(() => {
        getUbi()
    }, [])

    useEffect(() => {
        setTimeout(initialUbis(), 1000)
    }, [ubis, initialUbis])

    return (
        <div style={{ marginTop: '5px' }}>
            <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>

                <Grid item xs={12}>
                    <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>

                        {form.ultima_actualizacion &&
                            <Grid item xs={12} style={{ marginTop: '-20px' }}>
                                <div style={{ textAlign: 'right', fontSize: '12px', color: '#616161' }}>
                                    Actualizado:{' '}{moment(form.ultima_actualizacion).format('DD-MM-YY H:mm')}
                                </div>
                            </Grid>
                        }

                        {/* <Grid item xs={12}>
                            <div className='d-flex justify-content-center align-items-center p-container-foto'>
                                {(!selectedImage & !form.url_foto) ?
                                    <img
                                        src={iconUpPhoto} alt="subir foto"
                                        onClick={handleUpload}
                                    />
                                    :
                                    <Avatar
                                        alt={form.nombre}
                                        src={selectedImage ? URL.createObjectURL(selectedImage) : (form.url_foto ? form.url_foto : iconUpPhoto)}
                                        sx={{ width: 100, height: 100 }}
                                        onClick={handleUpload}
                                    />
                                }
                            </div>
                        </Grid> */}

                        {/* <input
                            style={{ display: 'none' }}
                            name="profile_picture"
                            id="profile_picture"
                            accept="image/*"
                            type="file"
                            onChange={imageChange}
                        />

                        {selectedImage && (
                            <DialogPreviewImage
                                open={openFiles}
                                setOpen={setOpenFiles}
                                setSelectedImage={setSelectedImage}
                                selectedImage={selectedImage}
                            />
                        )} */}

                        {form.id > 0 &&
                            <Grid item xs={12}>
                                <FormControlLabel
                                    // className="ms-2"
                                    control={
                                        <Switch
                                            style={{ color: form?.estado ? '#8E24AA' : '' }}
                                            name="estado"
                                            checked={form?.estado}
                                            onChange={handleChange}
                                        />
                                    }
                                    label={form?.estado ? 'Habilitado' : 'Desactivado'}
                                />
                            </Grid>
                        }


                        <Grid item xs={12}>
                            <FormControl>
                                {/* <FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel> */}
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="tipo"
                                    onChange={handleChange}
                                >
                                    <FormControlLabel
                                        value="empresa"
                                        control={<Radio style={{ color: '#8E24AA' }} checked={form.tipo === 'empresa' ? true : false} />}
                                        label="Empresa"
                                    />
                                    <FormControlLabel
                                        value="persona"
                                        control={<Radio style={{ color: '#8E24AA' }} checked={form.tipo === 'persona' ? true : false} />}
                                        label="Persona"
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <div className='p-info'>
                                <FormControl fullWidth size="small">
                                    <InputLabel id="demo-simple-select-label">Clasificación</InputLabel>
                                    <Select
                                        label="Clasificación"
                                        id="clasificacion"
                                        name="clasificacion"
                                        value={form.clasificacion || ''}
                                        onChange={handleChange}
                                        className='p-list-capitalize'
                                    >
                                        <MenuItem value='' key=''>Ninguno</MenuItem>
                                        {clasificacion.map(item => (
                                            <MenuItem value={item} key={item} className='p-list-capitalize'>
                                                {item}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                        </Grid>

                        <Grid item xs={12} sm={6}></Grid>

                        <Grid item xs={12} sm={6}>
                            <div className='p-info'>
                                {form.tipo === 'empresa' ?
                                    <TextField
                                        label="Nombre comercial"
                                        name="nombre_comercial"
                                        id="outlined-size-small"
                                        value={form.nombre_comercial || ''}
                                        size="small"
                                        fullWidth
                                        placeholder='Ingrese nombre comercial'
                                        onChange={handleChange}
                                    />
                                    :
                                    <TextField
                                        label="Nombre(s)"
                                        name="nombre"
                                        id="outlined-size-small"
                                        value={form.nombre || ''}
                                        size="small"
                                        fullWidth
                                        placeholder='Ingrese nombre(s)'
                                        onChange={handleChange}
                                    />
                                }
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <div className='p-info'>
                                {form.tipo === 'empresa' ?
                                    <TextField
                                        label="Rubro o actividad"
                                        name="rubro"
                                        id="outlined-size-small"
                                        value={form.rubro || ''}
                                        size="small"
                                        fullWidth
                                        placeholder='Ingrese rubro o actividad'
                                        onChange={handleChange}
                                    />
                                    :
                                    <TextField
                                        label="Apellidos"
                                        name="apellidos"
                                        id="outlined-size-small"
                                        value={form.apellidos || ''}
                                        size="small"
                                        fullWidth
                                        placeholder='Ingrese apellidos'
                                        onChange={handleChange}
                                    />
                                }
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <div className='p-info'>
                                {form.tipo === 'empresa' ?
                                    <TextField
                                        label="Razon Social"
                                        name="razon_social"
                                        id="outlined-size-small"
                                        value={form.razon_social || ''}
                                        size="small"
                                        fullWidth
                                        placeholder='Ingrese razon social'
                                        onChange={handleChange}
                                    />
                                    :
                                    <TextField
                                        label="Rubro o actividad"
                                        name="rubro"
                                        id="outlined-size-small"
                                        value={form.rubro || ''}
                                        size="small"
                                        fullWidth
                                        placeholder='Ingrese rubro o actividad'
                                        onChange={handleChange}
                                    />
                                }
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <div className='p-info'>
                                <TextField
                                    label={form.tipo === 'persona' ? 'DNI/RUC' : 'RUC/DNI'}
                                    name="nro_documento"
                                    id="outlined-size-small"
                                    value={form.nro_documento || ''}
                                    size="small"
                                    fullWidth
                                    placeholder={form.tipo === 'persona' ? 'Ingrese DNI' : 'Ingrese RUC'}
                                    onChange={handleChange}
                                />
                            </div>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <div className='p-info'>
                                <TextField
                                    label="Celular"
                                    name="celular"
                                    id="outlined-size-small"
                                    value={form.celular || ''}
                                    size="small"
                                    fullWidth
                                    placeholder='Ingrese teléfono'
                                    onChange={handleChange}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <div className='p-info p-box-email'>
                                <TextField
                                    label="Email"
                                    name="email"
                                    id="outlined-size-small"
                                    value={form.email || ''}
                                    size="small"
                                    fullWidth
                                    placeholder='Ingrese email'
                                    onChange={handleChange}

                                />
                            </div>
                        </Grid>

                    </Grid>
                </Grid>

                {openMas &&
                    <Grid item xs={12}>
                        <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>
                            <Grid item xs={12} sm={6}>
                                <div className='p-info'>
                                    <FormControl fullWidth size="small">
                                        <InputLabel id="demo-simple-select-label">Pais</InputLabel>
                                        <Select
                                            label="Pais"
                                            id="id_pais"
                                            name="id_pais"
                                            value={form.id_pais || ''}
                                            onChange={handleChangeUbi}
                                            className='p-list-capitalize'
                                        >
                                            <MenuItem value='' key=''>Ninguno</MenuItem>
                                            {selectedCountry?.map(item => (
                                                <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div className='p-info'>
                                    <FormControl fullWidth size="small">
                                        <InputLabel id="demo-simple-select-label">Departamento</InputLabel>
                                        <Select
                                            label="Departamento"
                                            id="id_departamento"
                                            name="id_departamento"
                                            value={form.id_departamento || ''}
                                            onChange={handleChangeUbi}
                                            className='p-list-capitalize'
                                        >
                                            <MenuItem value='' key=''>Ninguno</MenuItem>
                                            {selectedState?.map(item => (
                                                <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div className='p-info'>
                                    <FormControl fullWidth size="small">
                                        <InputLabel id="demo-simple-select-label">Provincia</InputLabel>
                                        <Select
                                            label="Provincia"
                                            id="id_provincia"
                                            name="id_provincia"
                                            value={form.id_provincia || ''}
                                            onChange={handleChangeUbi}
                                            className='p-list-capitalize'
                                        >
                                            <MenuItem value='' key=''>Ninguno</MenuItem>
                                            {selectedProvince?.map(item => (
                                                <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>{item.name}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div className='p-info'>
                                    <FormControl fullWidth size="small">
                                        <InputLabel id="demo-simple-select-label">Distrito</InputLabel>
                                        <Select
                                            label="Distrito"
                                            id="id_distrito"
                                            name="id_distrito"
                                            value={form.id_distrito || ''}
                                            onChange={handleChangeUbi}
                                            className='p-list-capitalize'
                                        >
                                            <MenuItem value='' key=''>Ninguno</MenuItem>
                                            {selectedDistric?.map(item => (
                                                <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>{item.name}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div className='p-info'>
                                    <TextField
                                        label="Dirección"
                                        name="direccion"
                                        id="outlined-size-small"
                                        value={form.direccion || ''}
                                        size="small"
                                        fullWidth
                                        placeholder='Ingrese dirección'
                                        onChange={handleChange}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div className='p-info'>
                                    <TextField
                                        label="Sitio web"
                                        name="sitio_web"
                                        id="outlined-size-small"
                                        value={form.sitio_web || ''}
                                        size="small"
                                        fullWidth
                                        placeholder='Ingrese sitio web'
                                        onChange={handleChange}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div className='p-info'>
                                    {form.tipo === 'empresa' ?
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                label="Fecha Aniversario"
                                                inputFormat="DD/MM/YYYY"
                                                name="aniversario"
                                                value={form.aniversario}
                                                onChange={handleChangeDate}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </LocalizationProvider>
                                        :
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                label="Fecha Nacimiento"
                                                inputFormat="DD/MM/YYYY"
                                                name="fecha_nacimiento"
                                                value={form.fecha_nacimiento}
                                                onChange={handleChangeDate2}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </LocalizationProvider>
                                    }
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div className='p-info'>
                                    <TextField
                                        label="Teléfono"
                                        name="telefono"
                                        id="outlined-size-small"
                                        value={form.telefono || ''}
                                        size="small"
                                        fullWidth
                                        placeholder='Ingrese teléfono'
                                        onChange={handleChange}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="outlined-multiline-static"
                                    name="descripcion"
                                    label="Notas"
                                    multiline
                                    rows={4}
                                    value={form.descripcion}
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                }

                <Grid item xs={12}>
                    <div className='d-flex justify-content-end'>
                        <button
                            className='button p-button-mas-info'
                            onClick={() => setOpenMas(!openMas)}
                            type='button'
                        >
                            {!openMas ? 'Más información' : 'Ocultar más información'}
                        </button>
                        <Button
                            id="id-button-save-ppto"

                            className='p-btn-primary'
                            variant="contained"
                            size='medium'
                            type='submit'
                        >
                            Guardar
                        </Button>
                    </div>
                </Grid>

            </Grid>
        </div>
    )
}
